export const DOCUMENT_MANAGEMENT_EXPORT_GENERIC_MESSAGE = 'Erro ao exportar. Tente novamente.';
